import React from "react";
import { ResponsiveImage } from "@quintype/components";
import { string, array, number, object, func } from "prop-types";

import "./story-card.m.css";

const CustomImageGalleryElement = ({ className, imageAspectRatio, element = {}, story, onClickHandler }) => {
  const images = element["story-elements"].map((image, index) => (
    <div key={index} styleName="custom-galley-image" className="custom-galley-image">
      <figure
        data-test-id="story-element-image-container"
        className={`story-element-image-gallery__image-container ${onClickHandler ? "custom-cursor" : ""}`}
        onClick={() => onClickHandler && onClickHandler(index)}
      >
        <picture>
          <ResponsiveImage
            slug={image["image-s3-key"]}
            metadata={image.metadata}
            aspectRatio={imageAspectRatio || [1, 1]}
            widths={[550]}
            imgParams={{ auto: ["format", "compress"] }}
            className={className || "story-element-image-gallery__image"}
            alt={image.title || story.headline}
          />
        </picture>{" "}
      </figure>
      <div styleName="data-wrapper">
        {image.title && <span styleName="name">{image.title}</span>}
        {image["image-attribution"] && <span styleName="attribute">{image["image-attribution"]}</span>}
      </div>
    </div>
  ));

  return (
    <div className="custom-element-image-gallery" data-test-id="custom-element-image-gallery">
      {images}
    </div>
  );
};

CustomImageGalleryElement.propTypes = {
  className: string,
  imageAspectRatio: array,
  defaultWidth: number,
  element: object,
  widths: array,
  story: object,
  onClickHandler: func,
};

export default CustomImageGalleryElement;
